import React, { Fragment, useMemo } from 'react';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';

// Components

import ModalHeader from '@common-components/headers/ModalHeader';

const MultiTaxHouseholdModal = props => {

    const {
        actions: {
            hideAllModals
        },
        bottomAnchors: [
            anchor_1,
        ],
        boundAnchor,
        modal: {
            modalData: {
                callbacks,
                filers,
                filteredFilers,
                primaryTaxFilerPersonId,
            }
        },
        modalHeaderProps,
        modalHeaderProps: {
            modalId
        }
    } = props;

    const handleHideClick = () => {
        hideAllModals();
    };

    const handleSave = () => {
        callbacks.forEach(cb => cb());
        hideAllModals();
    };

    const primaryTaxFilerName = useMemo(
        () => {
            const primaryTaxFiler = filers.find(f => f.filerPersonId === primaryTaxFilerPersonId);
            return primaryTaxFiler ? primaryTaxFiler.filerFullName : '';
        },
        [ filers, primaryTaxFilerPersonId ]
    );

    const getNonPrimaryTaxFilers = () => {
        return filteredFilers
            .map(f => {
                const {
                    filerFullName,
                    filerPersonId
                } = f;

                return (
                    <p key = { filerPersonId } data-testid = { `${modalId}-filer_${filerPersonId}` } >
                        <FormattedMessage
                            id = 'modals.multi_tax_household.who_not_related_to_primary'
                            values = { {
                                personName: <strong>{ filerFullName }</strong>,
                                br: <br />
                            } }
                        />
                    </p>
                );
            });
    };

    return (
        <Fragment>
            <div className = 'gi-modal__header__head' >
                <ModalHeader
                    { ...modalHeaderProps }
                    closeAllModals
                    hideAllModals = { hideAllModals }
                />
            </div>
            <div
                id = 'multiTaxHouseholdModal'
                data-testid = { `${modalId}_body` }
                className = 'gi-modal__body'
            >
                <FormattedMessage
                    id = 'modals.multi_tax_household.only_who_related_to_primary'
                    values = { {
                        personName: <strong>{ primaryTaxFilerName }</strong>
                    } }
                    tagName='p'
                />
                {
                    getNonPrimaryTaxFilers()
                }
            </div>
            <div className = 'gi-modal__footer' >
                <div className = 'grid-row controls' >
                    <div className = 'grid-offset-4 txt-left' >
                        <Button
                            className = 'usa-button usa-button--outline gi-button gi-button__outline'
                            data-testid={`${modalId}-cancel_btn`}
                            onClick = { handleHideClick }
                        >
                            <FormattedMessage id = 'button.cancel' />
                        </Button>
                        <Button
                            className = 'usa-button gi-button gi-button__primary'
                            data-testid={`${modalId}-save_btn`}
                            onClick = { handleSave }
                            inputRef = { boundAnchor(anchor_1) }
                        >
                            <FormattedMessage id = 'button.save' />
                        </Button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default MultiTaxHouseholdModal;
